import React, { useEffect, useState, FC, useContext, useMemo, useCallback } from 'react';
import { Icon, IconDeleteUser } from '../../../../base/icons';
/* eslint-disable flowtype/no-types-missing-file-annotation */
export interface NewRecentItemViewDispalyNameProps {
    index: number,
    onSelectUser: ()=> void;
}

const NewRecentItemViewDispalyName: FC<NewRecentItemViewDispalyNameProps> = props => {

    const { item } = props;

    const mayContactNameDelete = useCallback((contacts) => {

        let contactName = '';
        if(contacts.length > 1) {
            contacts.map((contact, index) => {
                if(index === 0) {
                    contactName = contactName + contact?.firstName + " " + contact?.lastName;
                } else {
                    contactName = contactName + ', ' + contact?.firstName + " " + contact?.lastName;
                }
            })
        } else {
            if(contacts[0].firstName){
                contactName = contactName.concat("", contacts[0].firstName); 
            }
            if(contacts[0].lastName){
                if(contactName){
                    contactName = contactName.concat(" ", contacts[0].lastName); 
                } else {
                    contactName = contactName.concat("", contacts[0].lastName); 
                }
            }
        }

        return (<div style={{display: 'flex'}}>
            <div style={{flex: 1}}>
                {contactName || "Contact Not Found."}
            </div>
            {!contacts[0].user && 
                <Icon
                    style={{marginRight: '10px'}}
                    color='#fff'
                    className = { 'o-phone-book--w-100--add-contact' }
                    size = { 26 }
                    src = { IconDeleteUser } />
                }
        </div>);
    },[])  

    const renderReceiversName = () => {
        switch (item?.callType) {
        case 'inbound': {
            return (
                <div
                    key = { item?.caller?._id }
                    className = 'o-user-list-item-name'>
                    {item?.caller ? item?.caller?.firstName !== '' && item?.caller?.firstName ? `${item?.caller?.firstName} ${item?.caller?.lastName}` : item?.caller?.phoneNumber : 'Deleted User' }
                </div>
            );

            break;
        }
        case 'outbound': {
            return (
                // item?.contacts?.map((contact, index) => (
                <div
                    key = {`new-recent-item-view${item?.contacts[0]?._id }-${item.id}`}
                    className = 'o-user-list-item-name'>
                    {mayContactNameDelete(item?.contacts) }
                </div>
                // ))
            );
        }
        case 'missed': {
            return (
                <div
                    key = { item?.caller?._id }
                    className = 'o-user-list-item-name'>
                    {item?.caller ? (item?.caller?.firstName !== '' && item?.caller?.firstName) ? `${item?.caller?.firstName} ${item?.caller?.lastName}` : item?.caller?.phoneNumber : 'Deleted User' }
                </div>
            );
        }
        }
    };

    return (
        <>

            { item.isGroupCall && item?.groups.map(group => (
                <div
                    key = { `new-recent-item-view${group._id}-${item.id}` }
                    className = 'o-user-list-item-name'>{group?.name || "Deleted Group"}
                </div>
            )) }
            {!item.isGroupCall && renderReceiversName()

            }
        </>
    );
};

NewRecentItemViewDispalyName.defaultProps = {
};

export default NewRecentItemViewDispalyName;
